import React from "react"
import { Clock, ChevronDown } from "lucide-react"
import type { TenantConfig } from "../../types"

const dayNames: Record<number, string> = {
    0: "Lunes",
    1: "Martes",
    2: "Miércoles",
    3: "Jueves",
    4: "Viernes",
    5: "Sábado",
    6: "Domingo"
};

interface RestaurantStatusBannerProps {
    isOpen: boolean;
    config: TenantConfig | null;
    isAccordionOpen: boolean;
    setIsAccordionOpen: (open: boolean) => void;
    orderTiming: string | null;
}

export const RestaurantStatusBanner: React.FC<RestaurantStatusBannerProps> = ({
    isOpen,
    config,
    isAccordionOpen,
    setIsAccordionOpen,
    orderTiming
}) => {
    if (isOpen) return null;

    return (
        <div className={`rounded-3xl p-6 border shadow-xl backdrop-blur-md animate-in fade-in slide-in-from-top-4 duration-500 ${config?.accept_scheduled_orders ? 'bg-amber-50/90 dark:bg-amber-900/10 border-amber-200 dark:border-amber-800' : 'bg-rose-50/90 dark:bg-rose-900/10 border-rose-200 dark:border-rose-800'}`}>
            <div className="flex items-center gap-4 mb-4">
                <div className={`w-12 h-12 rounded-2xl flex items-center justify-center shadow-lg ${config?.accept_scheduled_orders ? 'bg-amber-500 text-white' : 'bg-rose-500 text-white'}`}>
                    <Clock className="w-6 h-6" />
                </div>
                <div>
                    <h3 className={`text-lg font-black ${config?.accept_scheduled_orders ? 'text-amber-900 dark:text-amber-100' : 'text-rose-900 dark:text-rose-100'}`}>
                        {config?.accept_scheduled_orders ? 'Solo pedidos programados' : 'Restaurante Cerrado'}
                    </h3>
                    <p className={`text-sm font-medium ${config?.accept_scheduled_orders ? 'text-amber-700 dark:text-amber-300' : 'text-rose-700 dark:text-rose-300'}`}>
                        {config?.accept_scheduled_orders
                            ? 'Podés programar tu pedido para los próximos días.'
                            : 'En este momento no estamos tomando pedidos.'}
                    </p>
                </div>
            </div>

            <div className="space-y-3">
                <button
                    onClick={() => setIsAccordionOpen(!isAccordionOpen)}
                    className={`w-full flex items-center justify-between p-4 rounded-2xl transition-all duration-300 ${config?.accept_scheduled_orders ? 'bg-amber-100/50 dark:bg-amber-900/20 text-amber-800 dark:text-amber-200' : 'bg-rose-100/50 dark:bg-rose-900/20 text-rose-800 dark:text-rose-200'}`}
                >
                    <span className="text-sm font-bold">Ver horarios de atención</span>
                    <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${isAccordionOpen ? 'rotate-180' : ''}`} />
                </button>

                {isAccordionOpen && (
                    <div className="space-y-2 p-2 animate-in fade-in slide-in-from-top-2 duration-300">
                        {[0, 1, 2, 3, 4, 5, 6].map((day) => {
                            const ranges = config?.working_hours?.[day as keyof typeof config.working_hours] || [];
                            return (
                                <div key={day} className={`flex justify-between items-center text-sm py-2 border-b last:border-0 ${config?.accept_scheduled_orders ? 'border-amber-200/20' : 'border-rose-200/20'}`}>
                                    <span className={`font-semibold uppercase tracking-wider ${config?.accept_scheduled_orders ? 'text-amber-900/70 dark:text-amber-100/60' : 'text-rose-900/70 dark:text-rose-100/60'}`}>
                                        {dayNames[day]}
                                    </span>
                                    <span className={`font-mono font-black ${config?.accept_scheduled_orders ? 'text-amber-900 dark:text-amber-50' : 'text-rose-900 dark:text-rose-50'}`}>
                                        {ranges.length > 0
                                            ? ranges.map((r: any) => `${r.start} - ${r.end}`).join(', ')
                                            : <span className="opacity-50">Cerrado</span>
                                        }
                                    </span>
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};
